import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import HowToFix from '../shared/HowToFix';
import InlineModal from '../shared/InlineModal';

export default function ImageMetadataSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.status === 'failed' && result.images_with_large_metadata && (
                    <>
                        <ImageMetadataResult images={result.images_with_large_metadata} />

                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type ImageMetadataResultProps = {
    images: {
        metadata_size: number;
        size: number;
        url: string;
    }[];
};

function ImageMetadataResult({ images }: ImageMetadataResultProps) {
    return (
        <div className="description-meta">
            <InlineModal
                openLabel="See results list"
                modalTitle="Full list of images with large metadata"
                closeLabel="Close"
            >
                <div className="image-table-container large-metadata">
                    <div
                        className="image-table"
                        style={{ width: '100%' }}
                    >
                        <div className="image-table-row">
                            <div className="image-table-cell image">Image </div>
                            <div className="image-table-cell url">Url </div>
                            <div className="image-table-cell">Image size</div>
                            <div className="image-table-cell">Metadata size</div>
                            <div className="image-table-cell">Percent</div>
                        </div>

                        {images.map((image, idx) => {
                            return (
                                <div
                                    className="image-table-row"
                                    key={idx}
                                >
                                    <div className="image-table-cell image">
                                        <img
                                            src={image.url}
                                            alt=""
                                        />
                                    </div>
                                    <div className="image-table-cell url">
                                        <div className="truncated">
                                            <a
                                                href={image.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                title={image.url}
                                            >
                                                {image.url}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="image-table-cell right">{`${(image.size / 1024).toFixed(1)} Kb`}</div>
                                    <div className="image-table-cell right">{`${(image.metadata_size / 1024).toFixed(1)} Kb`}</div>
                                    <div className="image-table-cell right">{`${((image.metadata_size * 100) / image.size).toFixed(2)}%`}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </InlineModal>
        </div>
    );
}
